export default {
    state() {
        return {
            datePicker: {
                locale: 'sv',
                format: { year: 'numeric', month: 'numeric', day: 'numeric' }
            }
        };
    }
}
